import * as React from "react"
import { Box } from "@mui/material";

import {DIPSite} from "@components";
import { AdminProductReviewRetailerSelected } from "../../@signals"


export default function RetailerSelect({ onFinishAjax, optionsSelect }) {
	return <Box sx={{ mr: 2 }}>
        <DIPSite
            multiple
            label="Retailer"
            options={optionsSelect.filter(obj => obj.value === AdminProductReviewRetailerSelected.value[0])}
            placeholder="All Retailers"
            value={AdminProductReviewRetailerSelected.value}
            disableClearable
            onFinishAjax={onFinishAjax}
        />
    
    </Box>
}